module.exports = __webpack_public_path__ + "img/en-box4-text-dark.f53f01a9.png";